// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class RoleRecord extends VerofreshRecord {
}

export default RoleRecord
